import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";

const DocsPage = () => {
  const [markdown, setMarkdown] = useState("");

  useEffect(() => {
    fetch("/docs.md")
      .then((response) => response.text())
      .then((text) => setMarkdown(text))
      .catch((error) => console.error("Error loading markdown file:", error));
  }, []);

  return (
    <div className="p-4 max-w-2xl mx-auto border rounded-lg shadow-md bg-white">
      <div className="p-4">
        <ReactMarkdown
          components={{
            h1: ({ node, ...props }) => <h1 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#333' }} {...props} />,
            h2: ({ node, ...props }) => <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#555' }} {...props} />,
            h3: ({ node, ...props }) => <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#777' }} {...props} />,
          }}
        >{markdown}</ReactMarkdown>
      </div>
    </div>
  );
};

export default DocsPage;
